import { defineMessages } from 'react-intl';

const prefix = 'app.containers.TranslationSettings.CustomTerminology';

export const messages = defineMessages({
  customTerminologies: {
    id: `${prefix}.customTerminologies`,
    defaultMessage: 'Custom Terminologies',
  },
  customTerminologyDisabled: {
    id: `${prefix}.customTerminologyDisabled`,
    defaultMessage: 'Custom Terminology is not enabled for this account.',
  },
  downloadSampleFile: {
    id: `${prefix}.downloadSampleFile`,
    defaultMessage: 'Download Sample File',
  },
  errorLoadingTerminology: {
    id: `${prefix}.errorLoadingTerminology`,
    defaultMessage:
      'There was an error loading your Custom Terminology. Please try again later or contact support if the issue persists',
  },
  languageCodesInstruction: {
    id: `${prefix}.languageCodesInstruction`,
    defaultMessage: 'Use language codes as column headers',
  },
  maxFileSizeInstruction: {
    id: `${prefix}.maxFileSizeInstruction`,
    defaultMessage: 'The uploaded file must be at most 10MB',
  },
  maxTermLengthInstruction: {
    id: `${prefix}.maxTermLengthInstruction`,
    defaultMessage: 'Each term can be at most 100 characters long',
  },
  deleteSuccess: {
    id: `${prefix}.deleteSuccess`,
    defaultMessage: 'Your Custom Terminology has been deleted successfully',
  },
  processSuccess: {
    id: `${prefix}.processSuccess`,
    defaultMessage: 'Your Custom Terminology has been processed successfully',
  },
  replace: {
    id: `${prefix}.replace`,
    defaultMessage: 'Replace',
  },
  rowStructureInstruction: {
    id: `${prefix}.rowStructureInstruction`,
    defaultMessage:
      'Rows include translation pairings - provide one word or phrase per row in each language',
  },
  uploadCsvFile: {
    id: `${prefix}.uploadCsv`,
    defaultMessage: 'Upload CSV File',
  },
  uploadInstruction: {
    id: `${prefix}.uploadInstruction`,
    defaultMessage:
      'Upload a csv of any desired custom terminology to improve translations',
  },
});
